import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import useStripePaiement from "../../hooks/useStripePaiement";
import StripeCheckoutForm from "../../components/stripe/StripeCheckoutForm";
const PaiementStripe = ({setAlert}) => {
  const { stripePromise } = useStripePaiement();

  return (
    <>
      <Elements stripe={stripePromise}>
        <StripeCheckoutForm setAlert={setAlert}/>
      </Elements>
    </>
  );
};

export default PaiementStripe;
